import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P0003606, P0003606Data } from './P0003606';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';

export class P0004801 extends IProduct {
  override deviceTableIndex: number = 14;

  override modelIdentifier?: string = 'P00048-01';

  override dataIdentifier?: string = 'P0004801';

  override manufacturerName?: string = 'ACWA';

  data: P0003606Data = new P0003606Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0004801/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0004801/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0004801/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0004801;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0004801?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0004801.tuto.installation.help.title',
      helpSlides: [
        'P0004801.tuto.installation.help.1',
        'P0004801.tuto.installation.help.2',
        'P0004801.tuto.installation.help.3',
        'P0004801.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004801/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0004801/installation-1_dark.png',
          },
          text: 'P0004801.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004801/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0004801/installation-2_dark.png',
          },
          text: 'P0004801.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004801/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0004801/installation-1_dark.png',
          },
          text: 'P0004801.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0004801/update-2.png',
            dark: '/assets/ecosystem/images/products/P0004801/update-2_dark.png',
          },
          text: 'P0004801.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return new P0003606().getCPSConfig();
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return new P0003606().getEventProductFunctionalities();
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    return new P0003606().getCPSConfigByFonctionnality(functionnality);
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return new P0003606().getPropertyForOTAUpdate();
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 17;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).iphIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
